// extracted by mini-css-extract-plugin
module.exports = {"bb":"bb__antpv","basket-summary":"basket-summary__qIaLw","basket-summary__amount":"basket-summary__amount__GhpNN"};